<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
      <div class="form-group" id="commercial">
        <!-- <label class="col-sm-5 col-form-label font18 px-0">No. of locations</label> -->
        <div class="col-sm-12">
          <ng-select [items]="options"
          placeholder="Select"
          [searchable]="false" [clearable]="false"
          (change)="getLocations(no_of_locations);" [(ngModel)]="no_of_locations"></ng-select>
          <!-- <select (change)="getLocations($event);" [(ngModel)]="no_of_locations" class="dropdown-toggle form-control">
            <option *ngFor="let option of options" value={{option}}>{{option}}</option>
          </select> -->
        </div>
      </div>
    </div>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
      (click)="next();">Next</button>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 pl-0">
    <div class="form-group col-9 px-0 mt-2 pull-right" style="margin-bottom:6px !important">
      <!-- <label class="col-5 col-form-label text-right">No. of locations</label> -->
      <div class="col-sm-12 px-0" id="commercial">
        <ng-select [items]="options"
        placeholder="Select"
        [searchable]="false" [clearable]="false"
        (change)="getLocations(no_of_locations);" [(ngModel)]="no_of_locations"></ng-select>
        <!-- <select (change)="getLocations($event);" [(ngModel)]="no_of_locations" class="dropdown-toggle form-control">
          <option *ngFor="let option of options" value={{option}}>{{option}}</option>
        </select> -->
      </div>
    </div>
    <div style="width:100% !important; float:left;">
      <div *ngIf="user_bot" class="ash_box pull-right mt-2">
        <h1 class="ansMob text-right">{{no_of_locations}} locations</h1>
      </div>
    </div>
  </div>
</div>